export default function Footer() {
  return (
    <footer className="p-4 text-center text-gray-600 mt-10">
      © {new Date().getFullYear()} HandMade. All rights reserved.
    </footer>
  );
}
